import ContainerModel from '../container/ContainerModel';


export default class ModuleModel extends ContainerModel {

    constructor(dto: Object) {
        super(dto);
    }
}
